export function formatStatusLabel(value) {
  return String(value || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function badgeClass(status) {
  return `mm-customer-badge mm-customer-badge--${String(status || "operational")}`;
}
